import React from "react";
import { Tooltip } from "antd";
import MediaQuery from "react-responsive";
import Help from "../../../../../../assets/images/dashboard/help-icon.svg";
import ArrowBlack from "../../../../../../assets/images/dashboard/arrow-black.svg";
import Plus from "../../../../../../assets/images/dashboard/plus.svg";
import Minus from "../../../../../../assets/images/dashboard/minus.svg";
import Equal from "../../../../../../assets/images/dashboard/equal.svg";
import Rate from "../../../../../../assets/images/dashboard/rate.svg";
import Prize from "../../../../../../assets/images/dashboard/prize.svg";
import CardDetailsByGraph from "../component/CardDetailsByGraph"
import SeeMoreDetails from "../component/SeeMoreDetails"
import SeeMoreDetailsRewards from "../component/SeeMoreDetailsRewards";
import SeeMoreDetailsFeatures from "../component/SeeMoreDetailsFeatures";
import Carousel from "react-multi-carousel";
import {
    getCardImageURL,
    getFeaturesIcon,
    commaSeparator,
    valueWithCommas,
    getToolTipConstant,
    toFixedToDecimal,
    firstYear,
    secondYear,
    lastYear
} from "../../../../../../utils/constants"
import "../../../../../../common/styles/dashboard.scss"
import './CardDetails.scss';


function CardInfoPanel(args)  {
    
    const { 
        onGetDate,
        avgSpending,
        spending,
        selectedDate,
        topYearProjection, 
        topIncludedIntroBonus,
        selectedCategories,
        selectedFeatures,
        isTopPickHighlight=true,
        
        // 
        card,
        index, 
        updateCarouselHeight, 

        //
        sectionNumber=0,
        
    } = args;
    
    const {
        cardId,
        money,
        points,
        introMoney,
        introPoints,
        totalMoney,
        calculation = {},
        name = "",
        stat = [],
        link = "",
        cardInfo = "",
        features = [],
        rewardInfoLong = "",
        rewardRate = "",
        annualFee = "",
        creditRange = [],
        introOffer = "",
        introOfferGeneralDetail = [],
        moreDetailInfo = [],
        moreDetailNotes = [],
        unitForPoints = "",
        otherRewards = "",
        totalMoneyPerYear = "",
        introOfferDetail = [],
        annualFeeDisplay = [],
        annualFeeDetail = [],
        rewardRateGeneralDetail = [],
        annualFeeGeneralDetail = [],
        rewardDetail = []
    } = card || {};
    const { isReward, isIntro, isAnnual } = calculation || {};
    
    // 
    const cardDetailsByGraphObj = {
        stat, money, avgSpending, spending, onGetDate, selectedDate, topYearProjection,
        rewardInfoLong, features, otherRewards, annualFeeDisplay, annualFeeGeneralDetail, 
        creditRange, rewardRate, rewardRateGeneralDetail, introOffer, introOfferGeneralDetail
    };
    
    // 
    return (
        <div  id={"card-"+index} className={"tab-card-data" + ((index || !isTopPickHighlight)? "" : " top-pick-halo")} key={index.toString()}>
            
            {/* luci's pick ribbon */}
            {index === 0 && isTopPickHighlight ?
                <div className="card-carousel-top-pick">
                    <div className="top-pick-ribbon">luci's pick</div>
                </div> : null
            }
            
            {/* top section */}
            <div className="card-carousel-top">
                
                {/* card image */}
                <div className="card-carousel-image">
                    <img
                        className="cursor-pointer" src={getCardImageURL(cardId)}
                        onClick={() => window.open(link, "_blank")}
                    />
                </div>
                
                {/* card info */}
                <div className="card-carousel-info">
                    
                    {/* title */}
                    <div className="card-carousel-title">
                    
                        {/* bank name */}
                        {/* 
                        <div className="card-carousel-bank-name">-</div>
                        */}
                    
                        {/* card name */}
                        <div className="card-carousel-card-name">{name}</div>
                    
                        {/* apply button */}
                        <div className="card-carousel-submit-container">
                            <button
                                className={`btn luci-btn primary-btn font-weight-bold pt-3 pb-3 mb-3 ga-ccApply ga-ccApply-section${sectionNumber} ga-ccApply-cardId${cardId} ga-ccApply-slidepos${index+1}`}
                                type="submit"
                                onClick={() => window.open(link, "_blank")}
                            >
                                Apply
                            </button>
                        </div>
                    </div>
                    
                    {/* value */}
                    <div className="card-carousel-headline">
                    
                        {/* total reward */}
                        <div className="card-carousel-headline-element">
                            <div className="card-carousel-headline-label">
                                Luci Total Reward
                            </div>
                            <div className="card-carousel-headline-value">
                                <div>
                                    ${valueWithCommas(totalMoney || 0)}
                                </div>
                            </div>
                        </div>
                        
                        <div className="vert-divider"></div>
                        
                        {/* reward rate */}
                        <div className="card-carousel-headline-element">
                            <div className="card-carousel-headline-label">
                                Reward Rate
                            </div>
                            <div className="card-carousel-headline-value">
                                {rewardRate}
                                { !!(rewardRateGeneralDetail || []).length &&
                                    <Tooltip
                                        title={getToolTipConstant(rewardRateGeneralDetail || [])}
                                        trigger={["hover", "click"]}
                                    >
                                        <img className="gray-help ml-1" src={Help}/>
                                    </Tooltip>
                                }
                            </div>
                        </div>
                    </div>
                    
                    {/* summary */}
                    <div className="card-carousel-quicktake">
                    
                        {/* annual fee */}
                        <div className="card-carousel-quicktake-element">
                            <div className="card-carousel-quicktake-label">
                                Annual Fee
                            </div>
                            <div className="card-carousel-quicktake-value">
                                {(annualFeeDisplay || []).map((fee, index) => <span key={index.toString()}>{`${index === 0 ? fee : ` (${fee})`}`}</span>)}
                                { !!(annualFeeGeneralDetail || []).length &&
                                    <Tooltip
                                        title={getToolTipConstant(annualFeeGeneralDetail || [])}
                                        trigger={["hover", "click"]}
                                    >
                                        <img className="gray-help ml-1" src={Help}/>
                                    </Tooltip>
                                }
                            </div>
                        </div>
                        
                        {/* intro offer */}
                        {introOffer?
                            <>
                                <div className="vert-divider"></div>
                                <div className="card-carousel-quicktake-element">
                                    <div className="card-carousel-quicktake-label">
                                        Intro Offer
                                    </div>
                                    <div className="card-carousel-quicktake-value">
                                        {introOffer?.intro_description || ""}
                                        { !!(introOfferGeneralDetail || []).length &&
                                            <Tooltip
                                                title={getToolTipConstant(introOfferGeneralDetail || [])}
                                                trigger={["hover", "click"]}
                                            >
                                                <img className="gray-help ml-1" src={Help}/>
                                            </Tooltip>
                                        }
                                    </div>
                                </div>
                            </>
                            : null
                        }
                        
                        <div className="vert-divider"></div>
                        
                        {/* Recommended credit score */}
                        <div className="card-carousel-quicktake-element">
                            <div className="card-carousel-quicktake-label">
                                Recommended Credit Score
                            </div>
                            <div className="card-carousel-quicktake-value">
                                {creditRange.join(" - ")}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {/*  */}
            <SeeMoreDetailsRewards 
                {...{ 
                    card,
                    updateCarouselHeight,
                    topIncludedIntroBonus,
                    cardDetailsByGraphObj,
                }}
            />
            
            {/*  */}
            <SeeMoreDetailsFeatures
                {...{
                    card,
                    updateCarouselHeight,
                    topIncludedIntroBonus,
                    cardDetailsByGraphObj,
                }}
            />
            
        </div>
    );
}

export default CardInfoPanel;
